import { render, staticRenderFns } from "./CustomFoodLog.vue?vue&type=template&id=3e92d89d"
import script from "./CustomFoodLog.vue?vue&type=script&lang=js"
export * from "./CustomFoodLog.vue?vue&type=script&lang=js"
import style0 from "./CustomFoodLog.vue?vue&type=style&index=0&id=3e92d89d&prod&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports